import React, { FC } from 'react';
import CustomExternalAnchor from '../../../../@shared/customExternalAnchor';
import { CustomText } from '../../../../@shared/customText';
import Picture from '../../../../@shared/picture';
import { TSingleCard } from '../../../types/blogNews.types';

const Card: FC<TSingleCard> = (props): JSX.Element => {
  const { isEE, image, mobileImage, title, link, isGradientDisabled, textColor, cardHeadingTag } = props;
  return (
    <>
      <Picture
        editorialImageProps={{
          mobileImage: mobileImage,
          desktopImage: image,
          desktopTransformation: 'Size500',
          mobileTransformation: 'Size300',
          cssClassImageEl: 'stories-card__image',
        }}
      />
      <div className={`stories-card__content ${!isGradientDisabled ? 'stories-card__content--gradient' : ''}`} data-text-color={textColor}>
        <CustomText tag={cardHeadingTag} field={title} className={`stories-card__title rich-text stories-card__title--${textColor}`} />
        {isEE ? (
          <CustomExternalAnchor field={link} className={`stories-card__link stories-card__link--${textColor}`} />
        ) : (
          link?.value?.text && <span className={`stories-card__link stories-card__link--${textColor}`}>{link?.value?.text}</span>
        )}
      </div>
    </>
  );
};

export default Card;
